import React from "react";
import moment from "moment";
import { Flex, Box } from "grid-styled";
import { compose } from "redux";
import { reduxForm, Field } from "redux-form";
import setInitialValues from "../hocs/setInitialValues";
import { formatPrice } from "../utils/helpers";
import { InputContainer, DatePicker, Select } from "./forms";
import Button from "./Button";

const contractTypes = [
  { value: "Residential", label: "Residential" },
  { value: "Commercial", label: "Commercial" },
  { value: "Builder", label: "Builder" }
];

const ContractForm = ({ handleSubmit, cancel }) => {
  return (
    <form onSubmit={handleSubmit}>
      <Box pb={2}>
        <Field
          name="contractNumber"
          labelText="Contract Number"
          placeholder="e.g., C12345"
          component={InputContainer}
        />
      </Box>
      <Box pb={2}>
        <Field
          name="contractType"
          labelText="Contract Type"
          component={InputContainer}
          fieldComponent={Select}
          options={contractTypes}
        />
      </Box>
      <Box pb={2}>
        <Field
          name="description"
          labelText="Description"
          placeholder="e.g., Deck with patio"
          component={InputContainer}
        />
      </Box>
      <Box pb={2}>
        <Field name="amount" labelText="Amount" component={InputContainer} />
      </Box>
      <Box pb={2}>
        <Field
          name="effectiveDate"
          labelText="Effective Date"
          component={InputContainer}
          fieldComponent={DatePicker}
        />
      </Box>
      <Flex justify="flex-end">
        <Button type="button" onClick={cancel} style={{ marginRight: 4 }}>
          Cancel
        </Button>
        <Button type="submit" variant="primary">
          Save contract
        </Button>
      </Flex>
    </form>
  );
};

const enhance = compose(
  setInitialValues(({ job, contract }) => {
    let values = {
      contractNumber: job.contractNumber || "",
      contractType: job.contractType || ""
    };

    if (contract) {
      values = {
        ...values,
        description: contract.description,
        amount: formatPrice(contract.amountInCents),
        effectiveDate: moment(contract.effectiveDate).utc()
      };
    } else {
      values = {
        ...values,
        description: "",
        amount: "",
        effectiveDate: moment()
      };
    }

    return values;
  }),
  reduxForm({
    form: "contractForm"
  })
);

export default enhance(ContractForm);



// WEBPACK FOOTER //
// ./src/components/ContractForm.js